import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import Util from '../../../util/util';
import SendRecommenderFeedback from '../../../../../mutations/send_recommender_feedback_mutation';
import UploadingOverlay from '../../uploading-overlay/uploading_overlay';
import Info from '../../../../../components/info';
import {EVENT_ID, subscribe, unsubscribe} from '../../../../../containers/event_manager';
import * as tracking from '../../../../../tracking';
import AiIcon from '../../../../../images/ico-ai';

class suggestedTime extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOvertime: false,
			isNonWorkingDay: false,
		};

		this.inputBeforeSuggestedTimeTabbing = null;

		this.onTimeRegistrationEventReceived = this.onTimeRegistrationEventReceived.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	componentDidMount() {
		subscribe(EVENT_ID.TIME_REGISTRATION_MUTATION_SUCCESS, this.onTimeRegistrationEventReceived);
		if (this.props.usePopup) {
			window.addEventListener('keydown', this.handleKeyDown);
		}
	}

	componentWillUnmount() {
		unsubscribe(EVENT_ID.TIME_REGISTRATION_MUTATION_SUCCESS, this.onTimeRegistrationEventReceived);
		if (this.props.usePopup) {
			window.removeEventListener('keydown', this.handleKeyDown);
		}
	}

	handleKeyDown(e) {
		if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Tab') {
			return true;
		}

		const options = Array.from(document.querySelectorAll('.suggested-time-option'));

		if (options.length === 0) return true;

		const optionHasFocus = options.find(option => document.activeElement === option);
		if (e.key === 'Tab') {
			if (this.inputBeforeSuggestedTimeTabbing) {
				this.inputBeforeSuggestedTimeTabbing.focus();
				this.inputBeforeSuggestedTimeTabbing = null;
			} else {
				return true;
			}
		} else if (e.key === 'ArrowDown') {
			e.preventDefault();
			this.inputBeforeSuggestedTimeTabbing = document.activeElement;
			if (document.activeElement !== options[1]) {
				if (options[1].disabled) {
					options[0].focus();
				} else {
					options[1].focus();
				}
			}
		} else if (e.key === 'ArrowLeft') {
			e.preventDefault();
			if (optionHasFocus) {
				const arrayIndex = options.indexOf(optionHasFocus);

				if (arrayIndex - 1 >= 0) {
					if (options[arrayIndex - 1].disabled) {
						if (arrayIndex - 2 === 0) {
							if (!options[arrayIndex - 2].disabled) {
								options[arrayIndex - 2].focus();
							}
						}
					}
					options[arrayIndex - 1].focus();
				}
			}
		} else if (e.key === 'ArrowRight') {
			e.preventDefault();
			if (optionHasFocus) {
				const arrayIndex = options.indexOf(optionHasFocus);

				if (arrayIndex + 1 <= options.length - 1) {
					if (options[arrayIndex + 1].disabled) {
						if (arrayIndex + 2 <= options.length - 1) {
							if (!options[arrayIndex + 2].disabled) {
								options[arrayIndex + 2].focus();
							}
						}
					}
					options[arrayIndex + 1].focus();
				}
			}
		} else if (e.key === 'ArrowUp') {
			e.preventDefault();
			if (this.inputBeforeSuggestedTimeTabbing) {
				this.inputBeforeSuggestedTimeTabbing.focus();
				// this.inputBeforeSuggestedTimeTabbing = null;
			} else {
				return true;
			}
		}
	}

	// Round the incoming float
	// E.g. 4.25 => 4.5 or 4.125 => 4
	roundFloat(float, step) {
		step || (step = 1.0);
		var inv = 1.0 / step;
		return Math.round(float * inv) / inv;
	}

	onTimeRegistrationEventReceived(object) {
		const firstAlgorithm = 0;
		const secondAlgorithm = 1;
		const thirdAlgorithm = -1; // not a real algorithm, this is the third option that always shows the max
		const positive = 1.0;
		const negative = 0.0;
		const {timeRegisteredInHours, wasClickEvent} = object;
		// Don't send anything if timeRegisteredInHours is null
		if (timeRegisteredInHours === null) return;
		// The manually registered time matched the first algorithm's recommendation
		// We send positive feedback to it
		if (timeRegisteredInHours === this.currentFirstOption) {
			this.sendFeedback(firstAlgorithm, positive, wasClickEvent);
			// The manually registered time matched the second algorithm's recommendation
			// We send positive feedback to it
		} else if (timeRegisteredInHours === this.currentSecondOption) {
			this.sendFeedback(secondAlgorithm, positive, wasClickEvent);
			// The manually registered time didn't match any of the algorithm recommendations
			// We send negative feedback to both of them
		} else if (timeRegisteredInHours === this.currentThirdOption) {
			this.sendFeedback(thirdAlgorithm, positive, wasClickEvent);
		} else {
			this.sendFeedback(null, negative, wasClickEvent);
		}
	}

	getFirstTimeSuggestion(secondTimeSuggestion) {
		// Always select 0.5 if idleTime, unless secondTimeSuggestion is also 0.5
		const choice = this.props.inputParent && this.props.inputParent.idleTime ? (secondTimeSuggestion === 0.5 ? 0 : 1) : this.props.viewer.timeSuggestionsRecommender.recommendationId;
		const options = [0.25, 0.5, 0.75, 1.0, 1.5];

		this.currentFirstOption = options[choice];

		return options[choice];
	}

	getSecondTimeSuggestion(max) {
		// Always select fourthOption if idletime
		const choice = this.props.inputParent && this.props.inputParent.idleTime ? 3 : this.props.viewer.timeSuggestionsRecommenderTwo.recommendationId;
		let secondOption = (2 + (max - 1)) / 2;
		secondOption = this.roundFloat(secondOption, 0.5);
		const thirdOption = max === 0 ? max : max - 1;
		let fourthOption = max === 0 ? 1 : max / 2;
		fourthOption = this.roundFloat(fourthOption, 0.25);
		const options = [2, secondOption, thirdOption, fourthOption];

		this.currentSecondOption = options[choice];

		return options[choice];
	}

	/**
	 * Sends feedback to the recommender
	 * The recommender accepts 3 values: 0 - first algorithm, 1 - second algorithm, 3 - negative to both
	 * The value can be 0.0 (negative) or 1.0 (positive)
	 *
	 * @param {int} recommender
	 * @param {float} value
	 */
	sendFeedback(recommender, value, wasClickEvent) {
		const wasComponentDisplayed = this.props.timeSuggestionsEnabled;

		var algorithm;
		if (recommender === 0) {
			// leftmost option
			algorithm = 'first';
		} else if (recommender === 1) {
			// middle option
			algorithm = 'second';
		} else if (recommender === -1) {
			// rightmost option
			algorithm = 'third';
		} else {
			// no option was chosen - it is called "(both) were wrong" for compatibility with older data in Amplitude.
			algorithm = 'both';
		}

		tracking.trackEvent('[ML - Suggested Time]', {
			guess: recommender === null || value === 0.0 ? 'wrong' : 'right',
			algorithm: algorithm,
			clicked: !!wasClickEvent,
			wasComponentDisplayed,
		});

		// A non algorithm option was chosen
		// Send negative feedback to both our recommenders
		if (recommender === null || recommender === -1) {
			Util.CommitMutation(SendRecommenderFeedback, {
				recommendationInstanceId: this.props.viewer.timeSuggestionsRecommender.recommendationInstanceId,
				recommendationId: this.props.viewer.timeSuggestionsRecommender.recommendationId,
				generation: this.props.viewer.timeSuggestionsRecommender.generation,
				timeStep: this.props.viewer.timeSuggestionsRecommender.timeStep,
				feedbackValue: 0.0,
			});
			Util.CommitMutation(SendRecommenderFeedback, {
				recommendationInstanceId: this.props.viewer.timeSuggestionsRecommenderTwo.recommendationInstanceId,
				recommendationId: this.props.viewer.timeSuggestionsRecommenderTwo.recommendationId,
				generation: this.props.viewer.timeSuggestionsRecommenderTwo.generation,
				timeStep: this.props.viewer.timeSuggestionsRecommenderTwo.timeStep,
				feedbackValue: 0.0,
			});

			return;
		}

		// Otherwise, send positive feedback to the one that was chosen
		Util.CommitMutation(SendRecommenderFeedback, {
			recommendationInstanceId: recommender === 0 ? this.props.viewer.timeSuggestionsRecommender.recommendationInstanceId : this.props.viewer.timeSuggestionsRecommenderTwo.recommendationInstanceId,
			recommendationId: recommender === 0 ? this.props.viewer.timeSuggestionsRecommender.recommendationId : this.props.viewer.timeSuggestionsRecommenderTwo.recommendationId,
			generation: recommender === 0 ? this.props.viewer.timeSuggestionsRecommender.generation : this.props.viewer.timeSuggestionsRecommenderTwo.generation,
			timeStep: recommender === 0 ? this.props.viewer.timeSuggestionsRecommender.timeStep : this.props.viewer.timeSuggestionsRecommenderTwo.timeStep,
			feedbackValue: value,
		});
	}

	handleClickedTimeSuggestion(option) {
		const {inputParent} = this.props;
		const suggestedTimeInHours = option.value;
		const wasClickEvent = true;

		if (this.props.addTimeSuggestion) {
			this.props.addTimeSuggestion(inputParent, suggestedTimeInHours, true, wasClickEvent);
		}

		this.inputBeforeSuggestedTimeTabbing = null;
	}

	getWorkingDayInHours() {
		const {viewer, date} = this.props;

		let workingDayInMinutes = 0;
		// US start with sunday
		let days = [viewer.sunday, viewer.monday, viewer.tuesday, viewer.wednesday, viewer.thursday, viewer.friday, viewer.saturday];

		// If it's not US, we want to start with monday
		if (date.locale() !== 'en') {
			// Remove the first item from the array (sunday)
			const sunday = days.shift();
			// Push it at the end of the array so sunday now becomes the last day and monday the first
			days.push(sunday);
		}

		if (date && date.isValid()) {
			const dayIndex = date.weekday();
			workingDayInMinutes = days[dayIndex];
		}

		if (workingDayInMinutes === 0) {
			if (!this.state.isNonWorkingDay) {
				this.setState({isNonWorkingDay: true});
			}
		} else {
			if (this.state.isNonWorkingDay) {
				this.setState({isNonWorkingDay: false});
			}
		}

		return workingDayInMinutes / 60.0;
	}

	/*
	 * Returns the remaining available hours for a day, out of a full working day
	 * E.g. Working day = 8h, Person registered already 5h, Remaining = 3h
	 */
	getMax() {
		let max = 0;

		// One working day
		let workingDayHours = this.getWorkingDayInHours();
		const task = this.props.inputParent ? this.props.inputParent.task : null;

		// Calculate the total registered time for that day for that user
		let totalTimeRegisteredInHours = this.props.viewer.timeRegistrations ? this.props.viewer.timeRegistrations.edges.reduce((totalTimeRegistered, timeRegistration) => totalTimeRegistered + timeRegistration.node.minutesRegistered, 0) / 60.0 : 0;

		if (task) {
			const taskRemainingInHours = task.timeLeft / 60.0;

			// If remaining is 0 or is more than a full working day
			if (taskRemainingInHours === 0 || taskRemainingInHours >= workingDayHours) {
				// If the registered hours for the day is more than a full working day
				if (totalTimeRegisteredInHours >= workingDayHours) {
					max = 0;
				} else {
					max = workingDayHours - totalTimeRegisteredInHours;

					if (max < 1) {
						max = 1;
					}
				}
				// Remaining is between 0.1 and a full working day
			} else {
				max = taskRemainingInHours;

				if (max < 1) {
					max = 1;
				}
			}
			this.currentThirdOption = max;
			return max;
		}

		// If the person registered a full working day or more, we set the max to 0
		if (totalTimeRegisteredInHours >= workingDayHours) {
			max = 0;
		} else {
			// Otherwise, we subtract what the person already worked from the full day
			max = workingDayHours - totalTimeRegisteredInHours;

			if (max < 1) {
				max = 1;
			}
		}
		this.currentThirdOption = max;
		return max;
	}

	render() {
		if (this.props.loading) {
			return <UploadingOverlay />;
		}

		const {formatMessage} = this.props.intl;
		const {input, timeSuggestionsEnabled, usePopup} = this.props;
		const thirdSuggestion = this.getMax();
		const secondTimeSuggestion = this.getSecondTimeSuggestion(thirdSuggestion);
		const firstSuggestion = this.getFirstTimeSuggestion(secondTimeSuggestion);

		const options = [
			{id: 0, value: firstSuggestion},
			{id: 1, value: secondTimeSuggestion},
			{id: 2, value: thirdSuggestion},
		];

		if (!timeSuggestionsEnabled) {
			return null;
		}

		if (usePopup) {
			let top, left, height;
			top = input.getBoundingClientRect().top;
			left = input.getBoundingClientRect().left;
			height = input.getBoundingClientRect().height;

			return (
				<div className="suggested-time-container" style={input ? {top: top + height + 15 + 'px', left: left - 50 + 'px'} : ''}>
					<div className="header">
						<div className="title">{formatMessage({id: 'suggested_time.suggested_time'})}</div>
						<div className="info-container">{this.state.isNonWorkingDay ? <Info customClasses={'warning'} infoMessage={formatMessage({id: 'time_input.non_working_day'})} leftAligned={true} /> : null}</div>
					</div>

					<div className="options">
						{options.map(option => {
							return (
								<button onMouseDown={this.handleClickedTimeSuggestion.bind(this, option)} key={option.id} {...(option.value === 0 ? {disabled: true} : {})} className={'suggested-time-option' + (option.value === 0 ? ' disabled' : '')}>
									{Util.convertMinutesToFullHour(option.value * 60, this.props.intl)}
								</button>
							);
						})}
					</div>
				</div>
			);
		} else {
			return (
				<div className="nopopup-options">
					{options.map(option => {
						return (
							<div
								onMouseDown={this.handleClickedTimeSuggestion.bind(this, option)}
								key={option.id}
								{...(option.value === 0 ? {disabled: true} : {})}
								className={'suggested-time-option' + (option.value === 0 ? ' disabled' : '') + (this.props.selectedValue === option.value ? ' selected' : '')}
								tabIndex={0}
								onBlur={this.props.onOptionBlur}
							>
								<>
									<AiIcon useNewIcon={true} />
									{Util.convertMinutesToFullHour(option.value * 60, this.props.intl)}
								</>
							</div>
						);
					})}
				</div>
			);
		}
	}
}
suggestedTime.propTypes = {
	input: PropTypes.object,
	viewer: PropTypes.object,
};

const suggestedTimeQuery = graphql`
	query suggestedTime_Query($personId: ID, $dateString: String) {
		viewer {
			actualPersonId
			component(name: "suggested_time")
			...suggestedTime_viewer @arguments(personId: $personId, dateString: $dateString)
		}
	}
`;

export {suggestedTimeQuery};

export default injectIntl(
	createFragmentContainer(suggestedTime, {
		viewer: graphql`
			fragment suggestedTime_viewer on Viewer @argumentDefinitions(personId: {type: "ID"}, dateString: {type: "String"}) {
				timeSuggestionsRecommender {
					recommendationInstanceId
					recommendationId
					generation
					timeStep
				}
				timeSuggestionsRecommenderTwo {
					recommendationInstanceId
					recommendationId
					generation
					timeStep
				}
				monday
				tuesday
				wednesday
				thursday
				friday
				saturday
				sunday
				actualPersonId
				timeRegistrations(first: 100000, personId: $personId, date: $dateString) {
					edges {
						node {
							id
							day
							month
							year
							minutesRegistered
							person {
								id
							}
						}
					}
				}
			}
		`,
	})
);
